import { useCallback } from "react";

import { API_BASE_URL } from "@/api/api.config";
import useRestMutation from "@/remoteState/useRestMutation";

const useAssignmentViewRecordCreate = () => {
  const setAdminVisibilityControlsAddGroup = useCallback((data) => {
    const requestUrl = `${API_BASE_URL}/api/v2/student-assignment-view-record/`;

    const requestConfig = {
      method: "POST",
      body: JSON.stringify(data),
      headers: { "Content-Type": "application/json" },
    };

    return new Request(requestUrl, requestConfig);
  }, []);

  return useRestMutation(setAdminVisibilityControlsAddGroup);
};

export default useAssignmentViewRecordCreate;
